import * as React from 'react';
import styled from '@emotion/styled';
import { Icon } from '@vmos2/design-system';

type Props = { className: ?string, children: ?React.Node };
export const LoyaltyInfo = ({ className, children }: Props) => (
  <InfoWrapper className={className}>
    <InfoIcon name="InfoCircle" />
    <span data-test="loyalty-no-earn">{children}</span>
  </InfoWrapper>
);

LoyaltyInfo.defaultProps = {
  className: null,
  children: null,
};

const InfoWrapper = styled('div')`
  display: flex;
  margin-top: 24px;

  @media (${({ theme }) => theme.breakpoint.mobile}) {
    align-items: start;
  }
`;

const InfoIcon = styled(Icon)`
  margin-right: 8px;
  font-size: 20px;
`;
